import { Drawer } from "@components/ui/Drawer"
import { trackFilmInterest } from "@features/tracking/film-history"
import { trackEvent } from "@features/tracking/tracking"
import { TrackingHelpers } from "@features/tracking/tracking-helpers"
import { ContentBlocks } from "eddev/blocks"
import { useRoute } from "eddev/routing"
import { defineView } from "eddev/views"
import { useEffect, useMemo, useRef } from "react"

export default defineView("single-film", (props) => {
  const ref = useRef<HTMLDivElement>(null)

  const route = useRoute()

  useEffect(() => {
    trackEvent("View Film Page", { ...TrackingHelpers.filmAttrs(props.film) }, ref.current)
    trackFilmInterest(props.film?.uri || "", "pageview")
  }, [props.film])

  const content = useMemo(() => {
    const sidebar = props.film?.contentBlocks.find((block) => block.slug === "film/film-sidebar")?.innerBlocks
    return (
      <ContentBlocks
        blocks={props.film?.contentBlocks}
        wrapBlock={(children, { current }) => {
          // if (current.slug === "film/film-header") return <Drawer.SnapContainer>{children}</Drawer.SnapContainer>
          if (current.slug === "film/film-sidebar") return <></>
          if (current.slug === "film/film-contents")
            return (
              <div className="grid-auto">
                <div className="cols-film-main" data-film-main>
                  <ContentBlocks blocks={current.innerBlocks} />
                </div>
                <div className="cols-film-sidebar flex flex-col gap-4" data-film-sidebar>
                  <ContentBlocks blocks={sidebar} />
                </div>
              </div>
            )
          return children
        }}
      />
    )
  }, [props.film?.contentBlocks])

  return (
    <div ref={ref} data-mixpanel-template="Film Page" {...TrackingHelpers.filmAttrs(props.film)}>
      {content}
      <div className="h-10" />
    </div>
  )
})
